import { render, staticRenderFns } from "./two-players-preview.vue?vue&type=template&id=6a3d66b8&scoped=true&"
import script from "./two-players-preview.vue?vue&type=script&lang=js&"
export * from "./two-players-preview.vue?vue&type=script&lang=js&"
import style0 from "./two-players-preview.vue?vue&type=style&index=0&id=6a3d66b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3d66b8",
  null
  
)

export default component.exports